import { useReadContract } from "wagmi";

const useBaseUri = (address, abi, provider) => {
  return useReadContract({
    address: address,
    abi: abi,
    functionName: "getBaseURI",
    provider: provider
  });
};

export default useBaseUri;
